import React from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';
import DesktopAdminLayout from './layout/AdminLayout';
import MobileAdminLayout from '../mobile/components/layout/AdminLayout';

const ResponsiveAdminLayout = () => {
  const isMobile = useMediaQuery('(max-width: 599px)');

  return isMobile ? <MobileAdminLayout /> : <DesktopAdminLayout />;
};

export default ResponsiveAdminLayout; 